import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import {
  getRenterById,
  updateRenter,
} from "../../../../common/services/renters.api";
import FormEditPersonalData from "../forms/FormEditPersonalData";
import { IRenter } from "../../../../types/renter.type";
import Loading from "../../../../common/components/ui/loading/Loading";
import Pendencies from "../Pendencies";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";

type Props = {
  renterId: null | string;
  onClose: () => void;
};

export default function ModalEditRenter(props: Props) {
  const [renterId, setRenterId] = useState<string | null>(null);
  const { showToast } = useToastContext();
  const [renterData, setRenterData] = useState<IRenter | null>(null);
  const [formRequestErrors] = useState([]);

  const notifySuccess = (text) => showToast({ text, type: "success" });
  const notifyError = (text) => showToast({ text, type: "error" });

  const handleCloseModal = () => {
    props.onClose();
  };

  useEffect(() => {
    props.renterId !== renterId && setRenterId(props.renterId);
  }, [props.renterId, renterId]);

  useEffect(() => {
    async function loadRenterData(renterId: string) {
      if (!renterId) return;

      const { data, ok } = await getRenterById(renterId);

      if (ok) {
        setRenterData(data as IRenter);
      }
    }

    setRenterData(null);

    if (renterId) loadRenterData(renterId);
  }, [renterId]);

  async function saveRenter(dataToSave: IRenter) {
    try {
      const response = await updateRenter(renterId as string, dataToSave);

      const { ok, data, errors } = response;
      if (ok && data) {
        setRenterData(data as IRenter);
        notifySuccess(`Cliente "${renterData?.name}" atualizado!`);
        return {
          ok,
          data: data as IRenter,
          errors: errors as [{ message: string; path: string[] }],
        };
      }

      if (!ok) {
        notifyError(response.message as string);
      }

      return {
        ok,
        data: data as IRenter,
        errors: errors as [{ message: string; path: string[] }],
      };
    } catch (err) {
      console.log(err);
      notifyError("Erro ao tentar salvar cliente, tente novamente");
      return {
        ok: false,
        data: dataToSave,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        errors: [{ message: (err as any).message, path: [] }],
      };
    }
  }

  return (
    <Modal
      size={"5xl"}
      className="relative"
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header className="text-black">
        <div className="flex items-center justify-start gap-3 text-black">
          <span>{`Editando:1 ${(renterData || {})?.name}`}</span>
          {renterData ? (
            <Pendencies placement="bottom" renter={renterData} />
          ) : null}
        </div>
      </Modal.Header>
      <Modal.Body
        className="w-full relative border-gray flex flex-col text-black"
        style={{
          minHeight: "calc(100vh - 300px)",
          height: "calc(100vh - 300px)",
        }}
      >
        {renterData ? (
          <FormEditPersonalData
            data={renterData}
            onSubmit={saveRenter}
            formRequestErrors={formRequestErrors}
          />
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  );
}
